import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Space } from "antd";
import { observer } from "mobx-react";
import { useEffect } from "react";
import { CouponsTable } from "./couponsTable.js";
import { CreateCouponForm } from "./createCouponForm.js";
import { useStores } from "../../../../../../store/stores.js";
const CouponsPage = observer(()=>{
    const { accountV2Store: store, accountV2Store: { session } } = useStores();
    const affiliate = session?.affiliate;
    useEffect(()=>{
        store.fetchAffiliateProducts();
        affiliate?.fetchCoupons();
    }, []);
    return /*#__PURE__*/ _jsxs(Space, {
        direction: "vertical",
        size: 24,
        style: {
            width: "100%"
        },
        children: [
            /*#__PURE__*/ _jsx(CreateCouponForm, {}),
            /*#__PURE__*/ _jsx(CouponsTable, {})
        ]
    });
});
export { CouponsPage };
